export default "__VITE_ASSET__CLtDiimx__"